import React, { useState } from 'react';
import {
  Card, Row, Table,
} from 'react-bootstrap';
import { getCurrentStyle } from '../../../helpers/passport';
import { monthsArray } from '../../../stores/StratProject/StrategyStore';
import sortingArrow from '../../../../img/icons/sorting-arrow.svg';
import ProjectImpactTable from '../Partials/ProjectImpactTable';
import { useParams } from 'react-router';
import { getResultImpactLabel } from '../../../helpers/table';

export default function Results({
 data, acceptedData, letters, resultTypes, resultsImpact, trls, isNew,
}) {
  const [milestonesSorting, setMilestonesSorting] = useState('');
  const [milestonesSortingHover, setMilestonesSortingHover] = useState(false);
  const { stratId } = useParams();

  const mappedResults = data.results.map((r) => {
    const resType = resultTypes.find((rt) => rt.id === r.projResultTypeId);
    const resLetter = letters.find((l) => l.code === r.letterCode);

    return {
      ...r,
      type: resType && resType.name ? resType.name : '-',
      letter: resLetter && resLetter.code && resLetter.descr ? `${resLetter.code}) ${resLetter.descr}` : '-',
    };
  });

  return (
    <div className="read-only">
      <Card className="mb-4">
        <Card.Header as={Card.Title} className="p-4">Результаты проекта</Card.Header>
        <Card.Body className="p-4">
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">
              {isNew ? 'Описание итогового результата проекта' : 'Итоговый результат проекта (продукт)'}
            </Card.Subtitle>
            <Card.Text style={{ ...getCurrentStyle(data.status, data, acceptedData, 'result'), ...{ whiteSpace: 'pre-wrap' } }}>{data.result || '-'}</Card.Text>
          </Row>
          {isNew && (
            <Row className="mb-4">
              <Card.Subtitle className="mb-2 text-muted">Описание продукта проекта</Card.Subtitle>
              <Card.Text style={{ ...getCurrentStyle(data.status, data, acceptedData, 'productDescr'), ...{ whiteSpace: 'pre-wrap' } }}>{data.productDescr || '-'}</Card.Text>
            </Row>
          )}
          {!isNew && (
            <Row className="mb-4">
              <Card.Subtitle className="mb-3" style={{ fontWeight: 600 }}>Соответствие перечню важнейших наукоемких технологий</Card.Subtitle>
              <Row className="mb-3">
                <Card.Subtitle className="mb-2 text-muted">Критические технологии</Card.Subtitle>
                <Card.Text style={getCurrentStyle(data.status, data, acceptedData, 'criticalTech.name')}>
                  {data?.criticalTech?.name || '-'}
                </Card.Text>
              </Row>
              <Row>
                <Card.Subtitle className="mb-2 text-muted">Сквозные технологии</Card.Subtitle>
                <Card.Text style={getCurrentStyle(data.status, data, acceptedData, 'endToEndTech.name')}>
                  {data?.endToEndTech?.name || '-'}
                </Card.Text>
              </Row>
            </Row>
          )}
          <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">В том числе</Card.Subtitle>
            <Table striped className="read-view">
              <thead>
                <tr>
                  <th>Уникальный результат отчетного периода</th>
                  <th>Год</th>
                  <th>Тип</th>
                  <th>Единицы измерения</th>
                  <th>Значение</th>
                  <th>Мероприятие</th>
                </tr>
              </thead>
              <tbody>
                {mappedResults.map((res, index) => {
                  const acceptedResultElement = acceptedData?.results?.[index] ?? {};
                  return (
                    <tr key={res.id}>
                      <td style={getCurrentStyle(data.status, res, acceptedResultElement, 'title')}>{res.title}</td>
                      <td style={getCurrentStyle(data.status, res, acceptedResultElement, 'year')}>{res.year}</td>
                      <td style={getCurrentStyle(data.status, res, acceptedResultElement, 'projResultTypeId')}>{res.type}</td>
                      <td style={getCurrentStyle(data.status, res, acceptedResultElement, 'unit')}>{res.unit}</td>
                      <td style={getCurrentStyle(data.status, res, acceptedResultElement, 'value')}>{res.value}</td>
                      <td style={getCurrentStyle(data.status, res, acceptedResultElement, 'letterCode')}>{res.letter}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Row>
          {/* <Row className="mb-4">
            <Card.Subtitle className="mb-2 text-muted">Мероприятие Постановления № 729</Card.Subtitle>
            <Card.Text>
              <ListGroup>
                {lettersItems}
              </ListGroup>
            </Card.Text>
          </Row> */}
          <Row>
            <Card.Subtitle className="mb-2 text-muted">Потребитель продукта</Card.Subtitle>
            <Card.Text style={getCurrentStyle(data.status, data, acceptedData, 'consumers')}>{data.consumers || '-'}</Card.Text>
          </Row>
          {resultsImpact && resultsImpact.length !== 0 && (
            <div className="mt-3" style={{ borderTop: '2px solid #0D6EFD', borderBottom: '2px solid #0D6EFD', padding: '12px 0' }}>
              <ProjectImpactTable results={resultsImpact} trls={trls} />
            </div>
          )}
          {data.milestones && data.milestones.filter((milestone) => milestone.personsInCharge.length > 0).length > 0 && (
            <>
              <Card.Title className="mt-4">Вехи проекта</Card.Title>
              <Table striped className="read-view">
                <thead>
                  <th style={{ width: stratId ? '32%' : '46%' }}>Веха</th>
                  <th style={{ width: '18%' }}>Дата вып. (план)</th>
                  <th style={{ width: stratId ? '9%' : '18%' }}>УГТ (план)</th>
                  {stratId && <th style={{ width: '23%' }}>Выдающийся результат/веха СП, на который влияет проект</th>}
                  <th style={{ width: '18%' }}>Ответственный</th>
                </thead>
                <tbody>
                  {data.milestones.sort((a, b) => a.yearPlan - b.yearPlan || a.monthPlan - b.monthPlan).map((value) => (
                    <tr key={value.id} style={{ height: 96 }}>
                      <td style={{ width: stratId ? '23%' : '46%' }}>{value.name}</td>
                      <td style={{ width: '18%' }}>
                        {monthsArray[value.monthPlan - 1]}, {value.yearPlan}</td>
                      <td style={{ width: stratId ? '9%' : '18%' }}>{value.trlId || '-'}</td>
                      {stratId && <td style={{ width: '23%' }}>{getResultImpactLabel(value.stratResultId, resultsImpact)}</td>}
                      <td style={{ width: '18%' }}>
                        {getName(value.personsInCharge[0].displayName)}
                        <br />
                        {value.personsInCharge[0].post}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}

const getName = (name) => {
  const splitted = name.split(' ');
  const lastName = ` ${splitted[2][0]}.`;
  return `${splitted[0]} ${splitted[1][0]}.${splitted[2][0] ? lastName : ''}`;
};
